import "./formTravel.scss";
import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Spin,
  DatePicker,
  Select,
  notification,
  Divider,
} from "antd";
import { FormLayout } from "../../../../../layouts";
import { withRouter } from "../../../../../helpers/withRouter";
import {
  getFormPromise,
  updateFormBasicPromise,
  sendFormPromise,
} from "../../../promises";
import moment from "moment";
import Logo from "../../../../../layouts/commonComponent/components/Logo/Logo";
import { validateRutHelper,  validateCompanyRutHelper } from "../../../../../helpers";
import useFormsHooks from "../../hooks/useFormsHooks";
import { getOptList } from "../assets/optList";

const FormTravel = ({ form, match, formId }) => {
  const { t, i18n } = useTranslation(['forms']);
  const optList = getOptList()
  const { getFieldDecorator, getFieldsError, validateFields, setFieldsValue, getFieldError } = form;
  const [hasValidateMsg, setHasValidateMsg] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const [colLogo, setColLogo] = useState(4);

  const [date, setDate] = useState(0);
  const dateFormat = "DD/MM/YYYY";
  const { Option } = Select;
  const { TextArea } = Input;
  const [userId, setUserId] = useState("");
  const [subclienteId, setSubclienteId] = useState("0");
  const [apiForm, _setApiForm] = useState(null);
  const [format, setFormat] = useState("html");
  const [sentErrors, setSentErrors] = useState(0);
  const apiFormRef = useRef(apiForm);

  const setApiForm = data => {
    apiFormRef.current = data;
    _setApiForm(data);
  };

  const initVariablesFromObject = (obj, objs={}) => {
    let objs1 = {...objs}
    if (obj.json) {
      if (obj.json.baseParams) {
        let bParam = objToVariable(baseParamsIS, obj.json.baseParams);
        objs1['baseParams'] = bParam
      }
    }
    registerObjSections(objs1)
  };

  const handlerOnChangeObjAttr = async (sectionId, value, formObj) => {
    handleOnChangeField(sectionId, value)
    const binfo = entriesToObj(baseParams)

    if(!formObj) formObj = apiForm
    const json = { 
      baseParams: binfo,
    }
    let formToUpdate = { ...formObj, json };
    let ret = await saveFormPromiseLocal(formToUpdate);
    if(!ret.success) {
    //  setFieldsValue({[field]: ret.form[field]})
    }
  }

  const {
    getObjSection, 
    registerObjSections,  
    emailValidator,
    handleOnChangeField, 
    renderFormItemObj, 
    objToVariable, 
    entriesToObj,
    sendDocument,
    saveFormPromiseLocal,
    docValidator
  } = useFormsHooks({
    format,
    form,
    match,
    apiForm,
    setApiForm,
    handlerOnChangeObjAttr,
    initVariablesFromObject,
    optList
  });

  const baseParamsIS = {
    nombre: {
      key:'nombre', 
      maxLength:100, 
      title:t("forms.label.nombre"), 
      id:'baseParamsNombre',
      readOnly:true,
      disabled:true,
      type:'input'
    },
    rut: {
      key:'rut', 
      maxLength:100, 
      title:t("forms.label.doc"), 
      id:'baseParamsRut',
      readOnly:true,
      disabled:true,
      type:'input'
    },
    empresa: {
      key:'empresa', 
      maxLength:100, 
      title:t("forms.label.empresa"), 
      id:'baseParamsEmpresa',
      readOnly:true,
      disabled:true,
      type:'input'
    },
    empresaSecundaria: {
      key:'empresaSecundaria', 
      maxLength:100, 
      title:t("forms.label.empresa"), 
      id:'baseParamsEmpresaSecundaria',
      readOnly:true,
      type:'input'
    },
    gerencia: {
      key: 'gerencia',
      maxLength: 100,
      id: 'baseParamsGerencia',
      readOnly: true,
      type: 'input',
      title: t("forms.label.gerencia")
    },
    cargo: {
      key: 'cargo',
      maxLength: 100,
      id: 'baseParamsCargo',
      readOnly: true,
      type: 'input',
      title: t("forms.label.cargo")
    },
    jefatura: {
      key: 'jefatura',
      maxLength: 100,
      id: 'baseParamsJefatura',
      readOnly: true,
      type: 'input',
      title: t("forms.label.nombreGerenteCorportativo")
    },
    mailJefatura: {
      key: 'mailJefatura',
      maxLength: 100,
      id: 'baseParamsMailJefatura',
      readOnly: true,
      type: 'input',
      title: t("forms.label.emailGerenteCorporativo")
    },
    nombreAcom: {
      key: 'nombre',
      maxLength: 100,
      id: 'baseParamsNombreAcom',
      readOnly: true,
      type: 'input',
      title: t("forms.label.nombre")
    },
    tipoDoc: {
      key: 'tipoDoc',
      id: 'baseParamsTipoDoc',
      readOnly: true,
      type: 'select',
      title: t("forms.label.tipoDoc")
    },
    rutAcom: {
      key: 'rut',
      maxLength: 100,
      id: 'baseParamsRutAcom',
      readOnly: true,
      type: 'input',
      title: t("forms.label.doc")
    },
    gerenciaAcom: {
      key: 'gerencia',
      maxLength: 100,
      id: 'baseParamsGerenciaAcom',
      readOnly: true,
      type: 'input',
      title: t("forms.label.gerencia")
    },
    cargoAcom: {
      key: 'cargo',
      maxLength: 100,
      id: 'baseParamsCargoAcom',
      readOnly: true,
      type: 'input',
      title: t("forms.label.cargo")
    },
    empresaInvit: {
      key: 'organism',
      maxLength: 100,
      id: 'baseParamsEmpresaInvit',
      readOnly: true,
      type: 'input',
      title: t("forms.label.empresaInvitacion")
    },
    hasViaje: {
      key: 'hasViaje',
      maxLength: 100,
      id: 'baseParamsHasViaje',
      readOnly: true,
      type: 'select',
      title: t("forms.label.viaje")
    },
    hasViaticos: {
      key: 'hasViaticos',
      maxLength: 100,
      id: 'baseParamsHasViaticos',
      readOnly: true,
      type: 'select',
      title: t("forms.label.viaticos")
    },
    hasEstadia: {
      key: 'hasEstadia',
      maxLength: 100,
      id: 'baseParamsHasEstadia',
      readOnly: true,
      type: 'select',
      title: t("forms.label.estadia")
    },
    hasTransporte: {
      key: 'hasTransporte',
      maxLength: 100,
      id: 'baseParamsHasTransporte',
      readOnly: true,
      type: 'select',
      title: t("forms.label.transporte")
    },
    summary: {
      key: 'summary',
      maxLength: 4000,
      id: 'baseParamsSummary',
      readOnly: true,
      type: 'textArea',
      title: t("forms.label.sustentoParticipacion")
    },
    country: {
      key: 'country',
      maxLength: 50,
      id: 'baseParamsCountry',
      readOnly: true,
      type: 'input',
      title: t("forms.label.pais")
    },
    city: {
      key: 'city',
      maxLength: 50,
      id: 'baseParamsCity',
      readOnly: true,
      type: 'input',
      title: t("forms.label.ciudad")
    },
    initDate: {
      key: 'date',
      maxLength: 50,
      id: 'baseParamsInitDate',
      readOnly: true,
      type: 'date',
      title: t("forms.label.fechaInicio")
    },
    endDate: {
      key: 'endDate',
      maxLength: 50,
      id: 'baseParamsEndDate',
      readOnly: true,
      type: 'date',
      title: t("forms.label.fechaTermino")
    },
    value: {
      key: 'value',
      maxLength: 50,
      id: 'baseParamsValue',
      readOnly: true,
      type: 'input',
      title: t("forms.label.valorEstimadoTotal")
    },
    anomalies: {
      key: 'anomalies',
      maxLength: 4000,
      id: 'baseParamsAnomalies',
      readOnly: true,
      type: 'textArea',
      title: t("forms.label.comentariosAdicionales")
    },
  }
  const [keyBaseParams, baseParams] = getObjSection('baseParams')

  const validateLengthBaseParam = (field)=>
  {
    return {
      max: field.max,
      message: "Debe tener un máximo de "+ field.max + " caracteres"
    }
  }

  const testLengthBaseParams = (offset)=>{
    const test = Object.entries(baseParams).filter(([key,value])=>{
      return value.type!=='date'
    }).reduce((acu,item)=>{
      return {...acu, [item[1].id]: 'x'.repeat(item[1].max+offset)}
    },{})
    setFieldsValue(test)
    validateFields(Object.values(baseParams).map(obj=>obj.id))
  }

  const doTests = ()=>{
    setTimeout(()=>{
      testLengthBaseParams(1)
    },1000)
  }

  function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some((field) => fieldsError[field]);
  }

  const handleSubmit = async (e) => {
    let idForm = formId ? formId : match.params.id;  

    e.preventDefault();
    console.log(match);
    setHasValidateMsg(true);
    validateFields();
    if (hasErrors(getFieldsError())) {
      notification["warning"]({
        message: t("messages.aml.missingRequiredField", {ns: 'translations'}),
      });
    } else {
      sendDocument()
    }
  };


  useEffect(() => {
      const obj = { baseParams: baseParamsIS }
  
      let idForm = formId ? formId : match.params.id;  
  
      setIsloading(true);
      getFormPromise(idForm).then((response) => {
        if (
          response.data !== null &&
          response.data !== "" &&
          response.data.status !== undefined
        ) {
          setApiForm(response.data);
          initVariablesFromObject(response.data, obj)
          setUserId(response.data.recipient.request.createUser.id);
          if (response.data.recipient.record.subcliente !== null) {
            setSubclienteId(response.data.recipient.record.subcliente.id);
          }
          if(response.data.status === "SENT") {
            setDate(moment(response.data.receiveDate).format("DD-MM-YYYY"));
          }else {
            setDate(moment().format("DD-MM-YYYY"));
          }
        }
        setIsloading(false);
        if (match.params.view === "pdf") {
          setColLogo(5);
          setFormat("pdf");
        }
      });
    }, [i18n.language]);


  useEffect(() => {
    validateFields(["rutAcom"]);
  }, [apiForm]);


  return (
    <FormLayout
      currentUser={{ userId, subclienteId }}
      view={match.params.view === undefined ? "html" : match.params.view}
    >
      <div style={{ position: "relative" }}>
        {isLoading ? (
          <div className="form-header">
            <Row>
              <Col xs={9}></Col>
              <Col xs={6}>
                <div className="form-wrapper" style={{ textAlign: "center" }}>
                  <Spin style={{ fontColor: "#fff" }} size={"large"} />
                </div>
              </Col>
              <Col xs={9}></Col>
            </Row>
          </div>
        ) : (
          <>
            {apiForm !== null ? (
              <div
                className={
                  "form-content" +
                  (!hasValidateMsg ? " form-validate-messages" : "")
                }
              >
                <Row>
                  <Col>
                    <Form onSubmit={handleSubmit} className="form-form">
                      <Row
                        className="title-logo"
                        gutter={[0, 6]}
                        style={{
                          backgroundColor: "rgba(255,255,255,0.9)",
                          marginTop: "0px",
                          marginBottom: "0px",
                          textAlign: "left",
                          paddingTop: "10px",
                          paddingLeft: "10px",
                        }}
                      >
                        <Col
                          xs={24 - colLogo}
                          sm={24 - colLogo}
                          md={24 - colLogo}
                          lg={24 - colLogo}
                          xl={24 - colLogo}
                        >
                          <h3>
                            {t("forms.travel.title")}
                          </h3>
                        </Col>
                        <Col
                          className="logo-col"
                          xs={colLogo}
                          sm={colLogo}
                          md={colLogo}
                          lg={colLogo}
                          xl={colLogo}
                        >
                          <Logo currentUser={{ userId, subclienteId }} isForm={true} />
                        </Col>
                      </Row>

                      <Row
                        className="date"
                        gutter={[0, 6]}
                        style={{
                          backgroundColor: "rgba(255,255,255,0.9)",
                          marginTop: "0px",
                          marginBottom: "0px",
                          textAlign: "left",
                          paddingBottom: "15px",
                          paddingLeft: "10px",
                        }}
                      >
                        <Col span={2} style={{ textAlign: "left" }}>
                          {t("forms.label.fecha")}:
                        </Col>
                        <Col span={4}>
                          <div
                            className="formDate"
                            style={{
                              marginLeft: "5px",
                              borderStyle: "solid",
                              borderWidth: "1px",
                              borderColor: "#e8e8e8",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {date}
                          </div>
                        </Col>
                        <Col span={13} style={{ textAlign: "right" }}>
                          {t("forms.label.folio")}:
                        </Col>
                        <Col span={5}>
                          <div
                            className="formDate"
                            style={{
                              borderStyle: "solid",
                              borderWidth: "1px",
                              borderColor: "#e8e8e8",
                              display: "flex",
                              justifyContent: "center",
                              marginRight: "10px",
                              marginLeft: "8px",
                            }}
                          >
                            {apiForm.folio !== null ? apiForm.folio : ""}
                          </div>
                        </Col>
                      </Row>

                      {apiForm.status === "SENT" && format === "html" ? (
                        <>
                          <br />
                          <h3 style={{ textAlign: "center" }}>
                            {t("forms.messages.formWasSent1", {name: apiForm.recipient.record.nombre, ns: "forms"})}
                            <br />
                            {t("forms.messages.formWasSent2", {ns: "forms"})}:<br/><br/>
                            {apiForm.recipient.record.email}
                          </h3>
                        </>
                      ) : (
                        <>
                          <Row
                            className="lineamiento subheader"
                            style={{ marginTop: "0px" }}
                          >
                            <Col xl={24}>{t("forms.titles.lineamiento")}</Col>
                          </Row>

                          <Row className="summary">
                            <Col xl={24}>
                                {t("forms.sonda.travel.lineamiento.text1", {ns: 'formsSonda'})}
                              <br />
                              <br />
                                {t("forms.sonda.travel.lineamiento.text2", {ns: 'formsSonda'})}
                            </Col>
                          </Row>

                          <br />

                          <Row
                            className="subheader"
                            style={{
                              marginTop: "0px",
                            }}
                          >
                            <Col xl={24}>
                              {t("forms.titles.colaboradorRecibeColab")}
                            </Col>
                          </Row>

                          <Row className="content">
                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.nombre,
                                initialValue: apiForm.recipient.record.nombre,
                                disabled: true,
                                cols: 16,
                              })}

                              {renderFormItemObj({
                                initialValue: apiForm.recipient.record.rut,
                                section: baseParams.rut,
                                disabled: true,
                                cols: 8,
                              })}
                            </Row>

                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.empresa,
                                initialValue:
                                  apiForm.recipient.record.subcliente !== null
                                    ? apiForm.recipient.record.subcliente.name
                                    : apiForm.recipient.request.createUser
                                        .cliente.name,
                                disabled: true,
                                cols: 8,
                              })}

                              {renderFormItemObj({
                                section: baseParams.gerencia,
                                cols: 8,
                              })}
                              
                              {renderFormItemObj({
                                section: baseParams.cargo,
                                cols: 8,
                              })}
                            </Row>

                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.jefatura,
                                cols: 12,
                              })}

                              {renderFormItemObj({
                                section: baseParams.mailJefatura,
                                validator: emailValidator,
                                cols: 12
                              })}
                            </Row>
                          </Row>
                          <br />

                          <Row className="subheader">
                            <Col xl={24}>
                              {t("forms.titles.otroColaborador")}
                            </Col>
                          </Row>

                          <Row className="content">
                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.nombreAcom,
                                cols: 16,
                              })}

                              {renderFormItemObj({
                                section: baseParams.tipoDoc ,
                                cols: 8,
                              })}
                            </Row>
                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.rutAcom,
                                validator: docValidator(baseParams.tipoDoc.val),
                                cols:8
                              })}
                              {renderFormItemObj({
                                section: baseParams.empresaSecundaria,
                                cols: 8
                              })}
                              {renderFormItemObj({
                                section: baseParams.gerenciaAcom,
                                cols: 8,
                              })}
                            </Row>
                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.cargoAcom,
                                cols: 8
                              })}
                            </Row>
                          </Row>

                          <Row className="subheader">
                            <Col xl={24}>{t("forms.titles.datosInvitacion")}</Col>
                          </Row>

                          <Row className="content" style={{ padding: "0px" }}>
                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.empresaInvit,
                                colClassName: "leftLabel",
                                labelCol: 9,
                                wrapperCol: 15,
                                cols: 24
                              })}
                            </Row>

                            <Row className="fields-row" gutter={[16, 8]}>
                              <Divider orientation="left">{t("forms.label.alcanceInvitacion")}</Divider>
                            </Row>

                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.hasViaje,
                                colClassName: "leftLabel",
                                labelCol: 11,
                                wrapperCol: 13,
                                cols: 12,
                              })}

                              {renderFormItemObj({
                                section: baseParams.hasViaticos,
                                colClassName: "leftLabel",
                                labelCol: 11,
                                wrapperCol: 13,
                                cols: 12,
                              })}
                            </Row>

                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.hasEstadia,
                                colClassName: "leftLabel",
                                labelCol: 11,
                                wrapperCol: 13,
                                cols: 12,
                              })}

                              {renderFormItemObj({
                                section: baseParams.hasTransporte,
                                colClassName: "leftLabel",
                                labelCol: 11,
                                wrapperCol: 13,
                                cols: 12,
                              })}
                            </Row>

                            <Row
                              className="resumen"
                              style={{ paddingTop: "25px" }}
                            >
                              {renderFormItemObj({
                                section: baseParams.summary,
                                cols: 24,
                              })}
                            </Row>

                            <Row className="fields-row" gutter={[16, 8]}>
                              <Divider orientation="left">
                                {t("forms.label.lugarEvento")}
                              </Divider>
                            </Row>

                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.country,
                                colClassName: "leftLabel",
                                labelCol: 11,
                                wrapperCol: 13,
                                cols: 12,
                              })}

                              {renderFormItemObj({
                                section: baseParams.city,
                                colClassName: "leftLabel",
                                labelCol: 11,
                                wrapperCol: 13,
                                cols: 12,
                              })}
                            </Row>

                            <Row className="fields-row" gutter={[16, 8]}>
                              {renderFormItemObj({
                                section: baseParams.initDate,
                                cols: 8,
                              })}

                              {renderFormItemObj({
                                section: baseParams.endDate,
                                cols: 8,
                              })}

                              {renderFormItemObj({
                                section: baseParams.value,
                                cols: 8
                              })}
                            </Row>

                            <Row className="anomalies">
                              {renderFormItemObj({
                                section: baseParams.anomalies,
                                cols: 24
                              })}
                            </Row>

                            {format === "html" && (
                              <Row className="button-row">
                                <Col className="submitTrabajador" xl={24}>
                                  <Button
                                    type="primary"
                                    htmlType="submit"
                                  >
                                    {t("forms.buttons.send")}
                                  </Button>
                                </Col>
                              </Row>
                            )}
                          </Row>
                        </>
                      )}
                    </Form>
                  </Col>
                </Row>
              </div>
            ) : (
              <h2 style={{ textAlign: "center" }}>{t("forms.buttons.notFoundForm")}</h2>
            )}
          </>
        )}
      </div>
    </FormLayout>
  );
};

export default withRouter(Form.create()(FormTravel));
